// extracted by mini-css-extract-plugin
export default {"title":"CustomersVoice_title__2euVK","customers_title":"CustomersVoice_customers_title__gUNPt"};